// 콘솔 화면이 계약 목록·링크에서 고르는 규칙 — 클라이언트도 쓰므로 해시(node:crypto)를 딸고 오는 모듈을 부르지 않는다.

import { isShareLive } from "./share-live";
import type { Contract, ContractShare } from "./rows";

// 고객 계약 링크 경로(화면은 8번). 견적 링크(/s/)와 갈라 둔다.
export const contractSharePath = (token: string): string => `/c/${token}`;

// 살아 있는 링크 — listShares 가 최근 것부터라 첫 번째가 지금 링크다.
export const liveShareOf = (shares: readonly ContractShare[], at: string): ContractShare | null =>
  shares.find((s) => isShareLive(s, at)) ?? null;

// 견적의 살아 있는 계약 — 파기(VOID)만 뺀다. 해지·완료도 살아 있는 것으로 보는 건 의도(다시 계약하려면 새 견적 리비전), DB 유니크 인덱스는 동시 생성만 막으려 DRAFT·SENT·SIGNED 만 잠근다.
export const liveContractOf = <T extends Pick<Contract, "status">>(contracts: readonly T[]): T | null =>
  contracts.find((c) => c.status !== "VOID") ?? null;

// 고객 열람 기록 — 재발급한 링크까지 합쳐 센다(고객에게는 같은 계약서다).
export const contractViewRecordOf = (
  shares: readonly Pick<ContractShare, "view_count" | "last_viewed_at">[]
): { count: number; lastViewedAt: string | null } => ({
  count: shares.reduce((sum, s) => sum + s.view_count, 0),
  lastViewedAt: shares.reduce<string | null>(
    (max, s) => (s.last_viewed_at !== null && (max === null || s.last_viewed_at > max) ? s.last_viewed_at : max),
    null
  ),
});

// 상세 화면 한 줄 — 「고객 열람 n회 · 마지막 yyyy-mm-dd hh:mm」.
export const contractViewRecordText = (
  record: { count: number; lastViewedAt: string | null },
  format: (iso: string) => string
): string =>
  record.count === 0 ? "고객 열람 0회" : `고객 열람 ${record.count}회 · 마지막 ${record.lastViewedAt ? format(record.lastViewedAt) : "—"}`;
